import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue, KeyValueDefault } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { IPackageApi } from './base';
import {
  ChangeImportanceOrderRequest,
  PackageTypeDomainRequest,
  PackageTypeGetAllByCoutryIdRequest,
  PackageTypeRequest
} from '../models/request';
import { PackageTypeResponse } from '../models/response';

const baseRoute: string = 'PackageType';

export class PackageApi extends IPackageApi {
  getDomain(
    request: PackageTypeDomainRequest
  ): Promise<AxiosResponse<Result<KeyValueDefault[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }

  getAllByCoutryId(
    request: PackageTypeGetAllByCoutryIdRequest
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>> {
    return api.get(`${baseRoute}/getAllByCoutryId`, { params: request });
  }

  getByGuidPackageType(
    guidPackageType: string
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>> {
    return api.get(`${baseRoute}/getByGuidPackageType`, {
      params: { guidPackageType }
    });
  }

  changeImportanceOrder(
    request: ChangeImportanceOrderRequest
  ): Promise<AxiosResponse<Result<any>>> {
    return api.put(`${baseRoute}/changeImportanceOrder`, request);
  }

  save(
    request: PackageTypeRequest
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>> {
    return api.post(`${baseRoute}/save`, request);
  }

  update(
    request: PackageTypeRequest
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>> {
    return api.put(`${baseRoute}/update`, request);
  }

  delete(
    guidPackageType: string
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>> {
    return api.delete(`${baseRoute}/deactive`, { params: { guidPackageType } });
  }
}

